import {
  SET_ERROR,
  CLEAR_ERRORS,
  LOGIN,
  LOGOUT,
  VALID_TOKEN,
  INVALID_TOKEN,
  TOGGLE_SIDEBAR_NAV,
  CLOSE_SIDEBAR_NAV,
  SET_NOTIFICATION,
  CLEAR_NOTIFICATION,
  SET_FORM_TEMPLATE,
  CLEAR_FORM_TEMPLATE,
  BEGIN_REQUEST,
  END_REQUEST,
  RESIZE_WINDOW,
  CHANGE_INSTANCE,
  CHANGE_VIEW_AS,
  VERSION_MISMATCH,
  GLOBAL_SEARCH,
} from "../config/actionTypes";
import objectAssign from "object-assign";
import initialState from "./initialState";
import Flagship from "../core/flagship";

function normalizeAccessLevel(accessLevel) {
  let normalizedAccessLevel = Number(accessLevel);

  return isFinite(normalizedAccessLevel) &&
    Math.floor(normalizedAccessLevel) === normalizedAccessLevel
    ? normalizedAccessLevel
    : 0;
}

export default function flagshipMain(state = initialState.main, action) {
  let newState = objectAssign({}, state);

  switch (action.type) {
    case SET_ERROR:
      newState.errors = [...newState.errors, action.message];
      return newState;
    case CLEAR_ERRORS:
      newState.errors = [];
      return newState;
    case SET_NOTIFICATION:
      newState.notification = {
        message: action.payload.message,
        type: action.payload.type,
        show: true,
      };
      return newState;
    case CLEAR_NOTIFICATION:
      newState.notification = initialState.main.notification;
      return newState;

    case LOGIN:
      newState.isLoggedIn = true;
      newState.token = action.token;
      newState.accessLevel = normalizeAccessLevel(action.accessLevel);
      newState.username = action.username;
      newState.userFirstName = action.userFirstName;
      newState.userLastName = action.userLastName;
      newState.userId = parseInt(action.userId);
      newState.userPhoto = action.userPhoto;
      newState.userRole = action.userRole;
      newState.userMarket = action.userMarket;
      newState.userInstance = action.userInstance;
      newState.userViewAs = action.userViewAs;
      newState.instance = Flagship.getInstance(action.userInstance);
      newState.timeTracking = action.timeTracking;
      localStorage.setItem("flagshipToken", action.token);
      return newState;
    case LOGOUT:
      newState.isLoggedIn = false;
      newState.token = null;
      newState.accessLevel = 0;
      newState.userPhoto = null;
      newState.userFirstName = "Unauthorized";
      newState.userLastName = "User";
      newState.userRole = "None";
      newState.userMarket = "Unknown";
      newState.timeTracking = 0;
      localStorage.removeItem("flagshipToken");
      return newState;
    case VALID_TOKEN:
      newState.isLoggedIn = true;
      newState.token = action.token;
      newState.username = action.username;
      newState.userFirstName = action.userFirstName;
      newState.userLastName = action.userLastName;
      newState.userId = parseInt(action.userId);
      newState.userPhoto =
        action.username + ".jpg?cb_" + Math.floor(Math.random() * 999999);
      newState.userRole = action.userRole;
      newState.userMarket = action.userMarket;
      newState.userInstance = action.userInstance;
      newState.accessLevel = normalizeAccessLevel(action.accessLevel);
      newState.userViewAs = action.userViewAs;
      newState.instance = Flagship.getInstance(action.userInstance);
      newState.timeTracking = action.timeTracking;
      return newState;
    case INVALID_TOKEN:
      newState.isLoggedIn = false;
      newState.token = null;
      newState.userName = "";
      newState.accessLevel = 0;
      newState.userPhoto = null;
      newState.userFirstName = "Unauthorized";
      newState.userLastName = "User";
      newState.userRole = "None";
      newState.timeTracking = 0;
      newState.userMarket = "Unknown";
      return newState;
    case TOGGLE_SIDEBAR_NAV:
      newState.sidebarNavActive = !newState.sidebarNavActive;
      return newState;
    case SET_FORM_TEMPLATE:
      newState.formTemplate = objectAssign(
        action.payload.data,
        newState.formTemplate
      );
      return newState;
    case CLEAR_FORM_TEMPLATE:
      newState.formTemplate = {};
      return newState;
    case CLOSE_SIDEBAR_NAV:
      newState.sidebarNavActive = false;
      return newState;
    case CHANGE_INSTANCE:
      Flagship.setInstance(action.instance);
      newState.instance = action.instance;
      return newState;
    case BEGIN_REQUEST:
      newState.makingRequest = true;
      return newState;
    case END_REQUEST:
      newState.makingRequest = false;
      return newState;
    case RESIZE_WINDOW:
      newState.screenWidth = action.size;
      return newState;
    case CHANGE_VIEW_AS:
      newState.userViewAs = action.viewAs;
      return newState;
    case VERSION_MISMATCH:
      newState.versionMismatch = action.data;
      return newState;
    case GLOBAL_SEARCH:
      newState.search = action.search;
      return newState;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/appReducer.js